import CheckboxesComponent from "./CheckboxesComponent";
import DateComponent from "./DateComponent";
import FileInputComponent from "./FileInputComponent";
import NumberComponent from "./NumberComponent";
import OrgFinderComponent from "./OrgFinderComponent";
import PersonFinderComponent from "./PersonFinderComponent";
import RadioComponent from "./RadioComponent";
import RichTextComponent from "./RichTextComponent";
import SelectComponent from "./SelectComponent";
import TextareaComponent from "./TextareaComponent";
import TextComponent from "./TextComponent";
import UnitFinderComponent from "./UnitFinderComponent";

export default {
	text: TextComponent,
	richText: RichTextComponent,
	textarea: TextareaComponent,
	date: DateComponent,
	number: NumberComponent,
	radio: RadioComponent,
	select: SelectComponent,
	cayuseCheckboxes: CheckboxesComponent,
	fileInput: FileInputComponent,

	// Mapping to flowable's cayuse components
	"person-finder": PersonFinderComponent,
	"unit-finder": UnitFinderComponent,
	"org-finder": OrgFinderComponent
};
